import type { ReactNode } from "react";

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div style={{
      minHeight: "100vh", display: "grid", placeItems: "center",
      background: "radial-gradient(1200px 600px at 20% 0%, rgba(167,139,255,.18), transparent), var(--bg)"
    }}>
      <div className="card" style={{ width: "min(420px, 92vw)", padding: 28 }}>
        {children}
      </div>
    </div>
  );
}
